import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import LocContactDetails from "./LocContactDetails";

function LocContactsSettings({ register, setValue, getValues, errors }) {
  const { t, i18n } = useTranslation();
  const [technicalCheckBox, setTechnicalCheckBox] = useState(false);
  const [billingCheckBox, setBillingCheckBox] = useState(false);

  const handleCheckBox = (e, fieldName) => {
    try {
      setValue(fieldName, e.target.checked, {
        shouldDirty: true,
      });
      console.log("handleCheckBox ::", technicalCheckBox);
    } catch (e) {
      console.error("[.js][handleCheckBox] :" + e);
    }
  };

  return (
    <>
      <div id="contacts">
        <div className="routing-border mt-2"></div>
        <div className="general-settings">{t("Contacts")}</div>
        <h6 className="add-numbermain noHoverBg">{t("Primary")}</h6>

        <LocContactDetails
          register={register}
          errors={errors}
          firstName="contacts.primary.fname"
          lastName="contacts.primary.lname"
          email="contacts.primary.email"
          number="contacts.primary.number"
        />


        <div className=" py-2">


          <h6 className="add-numbermain noHoverBg">{t("Technical")}</h6>

          <div className="add-numbermain mt-2">


            <div className="tel-numbers">{t("UsePrimaryContact")}</div>
            <div className="phoneselect">
              <label className="switch">
                <input
                  className="form-control"
                  type="checkbox"
                  name="DefualtLocation"
                  id="toggleCheckbox"

                  checked={getValues(`contacts.technical.same_as_primary`)}
                  onChange={(e) => {
                    // setTechnicalCheckBox((obj) => !obj);
                    handleCheckBox(e, "contacts.technical.same_as_primary");
                  }}
                />
                <span className="slider round"></span>
              </label>
            </div>


            {/* <MDBCheckbox
              name="flexCheck"
              value=""
              id="toggleCheckbox"
              label="Use primary contact"
              checked={getValues(`contacts.technical.same_as_primary`)}
              onChange={(e) => {
                // setTechnicalCheckBox((obj) => !obj);
                handleCheckBox(e, "contacts.technical.same_as_primary");
              }}
            /> */}
          </div>
        </div>
        {!getValues("contacts.technical.same_as_primary") && (
          <LocContactDetails
            register={register}
            errors={errors}
            firstName="contacts.technical.fname"
            lastName="contacts.technical.lname"
            email="contacts.technical.email"
            number="contacts.technical.number"
          />
        )}


        <h6 className="add-numbermain noHoverBg">{t("billing")}</h6>
        <div className="add-numbermain mt-2">


          <div className="tel-numbers">{t("UsePrimaryContact")}</div>




          <div className="phoneselect">
            <label className="switch">
              <input
                className="form-control"
                type="checkbox"
                name="DefualtLocation"
                id="toggleCheckboxBilling"
                checked={getValues(`contacts.billing.same_as_primary`)}
                onChange={(e) => {
                  // setBillingCheckBox((obj) => !obj);
                  handleCheckBox(e, `contacts.billing.same_as_primary`);
                }}
              />
              <span className="slider round"></span>
            </label>
          </div>


          {/* <MDBCheckbox
              name="flexCheck"
              value=""
              id="toggleCheckboxBilling"
              label="Use primary contact"
              checked={getValues(`contacts.billing.same_as_primary`)}
              onChange={(e) => {
                // setBillingCheckBox((obj) => !obj);
                handleCheckBox(e, `contacts.billing.same_as_primary`);
              }}
            /> */}
        </div>
        {!getValues(`contacts.billing.same_as_primary`) && (
          <LocContactDetails
            register={register}
            errors={errors}
            firstName="contacts.billing.fname"
            lastName="contacts.billing.lname"
            email="contacts.billing.email"
            number="contacts.billing.number"
          />
        )}
        <div className="routing-border mt-2"></div>
      </div >
    </>
  );
}

export default LocContactsSettings;
